export default __webpack_public_path__ + "8cb36e957f20ea0f8f493c90daa90c00.png";